import { render, staticRenderFns } from "./informationDetails.vue?vue&type=template&id=03e1fcce&scoped=true"
import script from "./informationDetails.vue?vue&type=script&lang=js"
export * from "./informationDetails.vue?vue&type=script&lang=js"
import style0 from "../../assets/commoon/css/common.css?vue&type=style&index=0&id=03e1fcce&prod&scoped=true&lang=css&external"
import style1 from "./informationDetails.vue?vue&type=style&index=1&id=03e1fcce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e1fcce",
  null
  
)

export default component.exports